<template>
  <div>
    <el-button :type="buttonType" :plain="true" @click="showEditImageDialog" size="minimum">{{ buttonText }}</el-button>
    <el-dialog title="" :visible.sync="editImageDialogVisible">
      <el-upload
              :action="uploadUrl"
              :http-request="uploadFile"
              :file-list="files"
              list-type="picture-card"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :disabled="!editable"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="showImageDialogVisible" append-to-body>
        <img width="100%" :src="showImageUrl" alt="">
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
  import AttachmentServer from '@/api/attachment'
  import { ATTACHMENT_SERVER } from "@/api";

  export default {
    name: "ImageEdit",
    props: {
      ownerTable: {},
      docType: {},
      ownerId: {},
      editable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        editImageDialogVisible: false,
        showImageDialogVisible: false,
        showImageUrl: false,
        files: [],
      };
    },
    computed: {
      uploadUrl() {
        return `${ATTACHMENT_SERVER}/file/upload/${this.ownerTable}/${this.docType}/${this.ownerId}`;
      },
      buttonType() {
        return this.files.length > 0 ? 'success' : '';
      },
      buttonText() {
        return this.files.length > 0 ? '查看' : '添加';
      },
    },
    methods: {
      showEditImageDialog() {
        this.editImageDialogVisible = true;
      },
      handleRemove(file, fileList) {
        AttachmentServer.attachment.delete(file.docLinkSid).then(responseBody => {
          this.$message("删除成功");
          this.downloadList();
        })
      },
      handlePreview(file) {
        this.showImageUrl = file.url;
        this.showImageDialogVisible = true;
      },
      uploadFile(e) {
        let params = {
          file: e.file,
          ownerTable: this.ownerTable,
          docType: this.docType,
          ownerId: this.ownerId,
        }
        AttachmentServer.attachment.upload(params).then(responseBody => {
          this.$message("上传成功");
          this.downloadList();
        })

      },
      downloadList() {
        let params = {
          ownerTable: this.ownerTable,
          ownerId: this.ownerId,
        }
        AttachmentServer.attachment.downloadList(params).then(responseBody => {
          this.files = responseBody;
        });
      },

    },
    watch: {
      ownerId: {
        immediate: true,
        deep: true,
        handler: function () {
          this.downloadList();
        }
      },
    }
  }
</script>

<style scoped>

</style>